/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  geofenceData: [],
};

/**
 * Capture actions dispatched and modify state accordingly
 * @param {*} state -> updated state
 * @param {*} action -> type of action dispatched
 */
const geofence = (state = initialState, action) => {
  switch (action.type) {
    // set geofenceData in state
    case actionTypes.SET_GEOFENCE:
      return {
        geofenceData: state.geofenceData.concat(action.data),
      };

    // update geofenceData in state
    case actionTypes.UPDATE_PROPERTIES:
      return {
        geofenceData: action.data,
      };

    // clear geofenceData in state
    case actionTypes.CLEAR_GEOFENCE:
      return {
        geofenceData: [],
      };

    default:
      return state;
  }
};

export default geofence;
